import React from 'react';
import { Typography } from '@mui/material';
import { Box } from './MuiCompat';
import { BlogPost } from '../types/blog';

interface BlogPostContentProps {
  post: BlogPost;
}

const BlogPostContent: React.FC<BlogPostContentProps> = ({ post }) => {
  // Function to render content based on available data
  const renderContent = () => {
    // If we have full content from API, render it
    if (post.content) {
      return (
        <Box
          sx={{
            '& p': { 
              margin: '1.5rem 0', 
              color: '#4a4a4a', 
              lineHeight: 1.6 
            },
            '& h1, & h2': { 
              textAlign: 'center', 
              fontWeight: 'bold', 
              color: '#1a1a1a',
              margin: '2rem 0 1rem'
            },
            '& h1': { fontSize: '1.5rem' },
            '& h2': { fontSize: '1.25rem' },
            '& ul': { 
              color: '#4a4a4a', 
              margin: '1.5rem 0', 
              paddingLeft: '2rem' 
            },
            '& li': { 
              marginBottom: '0.5rem', 
              color: '#4a4a4a' 
            },
            '& em': { fontStyle: 'italic' },
            '& strong': { fontWeight: 'bold' },
            '& a': { 
              color: '#4a4a4a', 
              textDecoration: 'underline',
              '&:hover': { opacity: 0.8 }
            }
          }}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      );
    }

    // Fallback: Generate content from excerpt and other available data
    return (
      <Box>
        <Typography 
          variant="body1" 
          sx={{ 
            fontSize: '1.125rem', 
            lineHeight: 1.8, 
            color: '#4a4a4a',
            marginBottom: '2rem'
          }}
        >
          {post.excerpt}
        </Typography>
        
        {post.tags_list && post.tags_list.length > 0 && (
          <Box sx={{ marginTop: '3rem' }}>
            <Typography 
              variant="h2" 
              sx={{ 
                fontSize: '1.25rem', 
                fontWeight: 'bold', 
                color: '#1a1a1a',
                textAlign: 'center',
                marginBottom: '1rem'
              }}
            >
              Topics Covered
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
              {post.tags_list.map((tag, index) => (
                <Box
                  key={index}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    color: '#4a4a4a',
                    padding: '0.5rem 1rem',
                    borderRadius: '1rem',
                    fontSize: '0.875rem',
                    fontWeight: 'medium'
                  }}
                >
                  {tag}
                </Box>
              ))}
            </Box>
          </Box>
        )}
        
        <Typography 
          variant="body2" 
          sx={{ 
            marginTop: '3rem',
            color: '#6a6a6a',
            fontStyle: 'italic',
            textAlign: 'center'
          }}
        >
          This article has been viewed {post.view_count} times.
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ 
      fontFamily: "'Georgia', Times, 'Times New Roman', serif",
      lineHeight: 1.6,
      textAlign: 'justify'
    }}>
      {renderContent()}
    </Box>
  );
};

export default BlogPostContent;